import { useMemo } from "react";
import { Layout } from "components";
import { Navigate, Outlet, useLocation, useSearchParams } from "react-router-dom";
import { Routes } from "router";

const getStep = (pathname: string) => {
  return pathname.split("/").pop();
};

const BookingCreation = () => {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const stepName = getStep(pathname);

  const stepNumber = useMemo(
    () => ({
      [Routes.HallSelection]: 1,
      [Routes.TimeSelection]: 2,
      [Routes.EquipmentSelection]: 3,
      [Routes.BookingDetailPreview]: 4,
    }),
    [],
  );

  const step = stepNumber[stepName as keyof typeof stepNumber];

  const setPrevUrl = useMemo(() => {
    switch (step) {
      case 2:
        return `${Routes.BookingCreationHallSelection}?${searchParams.has("h") ? `h=${searchParams.get("h")}` : ""}`;
      case 3:
        return `${Routes.BookingCreationTimeSelection}?${searchParams.has("h") ? `h=${searchParams.get("h")}` : ""}${searchParams.has("d") ? `&d=${searchParams.get("d")}` : ""}${searchParams.has("t") ? `&t=${searchParams.get("t")}` : ""}`;
      case 4:
        return `${Routes.EquipmentSelection}?${searchParams.toString()}`;
      default:
        return Routes.BookingCreationHallSelection;
    }
  }, [searchParams, step]);

  if (!step) {
    return <Navigate to={Routes.BookingCreationHallSelection} />;
  }

  return (
    <Layout
      prevStepUrl={setPrevUrl}
      isPreviousStepAvailable={step !== 1}
      isSkipStepAvailable={step === 3}
    >
      <Outlet />
    </Layout>
  );
};

export default BookingCreation;
